// Function to update ARIA labels and active class
function updateTabState($tab, isActive) {
    $tab.attr("aria-selected", isActive ? "true" : "false");
    if ($tab.attr("aria-haspopup")) {
        $tab.attr("aria-expanded", isActive ? "true" : "false");
    }
    if (isActive) {
        $tab.addClass("active");
    } else {
        $tab.removeClass("active");
    }
}

// Event handler for click and keypress events
$("ul.skiplink li a").on("click keypress", function (event) {
    if (event.type === "click" || (event.type === "keypress" && event.which === 13)) {
        // Remove active class and update ARIA labels for all tabs
        $("ul.skiplink li a").each(function () {
            updateTabState($(this), false);
        });
        // Add active class and update ARIA labels for the current tab
        updateTabState($(this), true);
    }
});

// Update active tab on scroll
$(window).on("scroll", function () {
    $("ul.skiplink-content li").each(function () {
        if ($(window).scrollTop() >= $(this).offset().top) {
            var id = $(this).attr("id");
            // Remove active class and update ARIA labels for all tabs
            $("ul.skiplink li a").each(function () {
                updateTabState($(this), false);
            });
            // Add active class and update ARIA labels for the current tab
            updateTabState($("ul.skiplink li a[href='#" + id + "']"), true);
        }
    });
});

// Set the default active tab
var hash = window.location.hash;
var $defaultTab = hash ? $("ul.skiplink li a[href='" + hash + "']") : $("ul.skiplink li a:first");
updateTabState($defaultTab, true);

// Add tabindex for accessibility
$("ul.skiplink li a").attr("tabindex", "0");

// Add ARIA roles for accessibility
$("ul.skiplink").attr("role", "tablist");
$("ul.skiplink li").attr("role", "presentation");
$("ul.skiplink li a").attr("role", "tab");
